import { render, staticRenderFns } from "./SupportCenter.vue?vue&type=template&id=5ae102c2"
import script from "./SupportCenter.vue?vue&type=script&lang=js"
export * from "./SupportCenter.vue?vue&type=script&lang=js"
import style0 from "./SupportCenter.vue?vue&type=style&index=0&id=5ae102c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports